import Index from './index.vue'
import Inbox from './components/Inbox'

export default [
  {
    path: '/home',
    name: 'home',
    component: Index,
    title: 'Home',
    redirect: { name: 'inbox-view' },
    children: [
      {
        path: 'inbox',
        name: 'inbox-view',
        component: Inbox,
      },
    ],
  },
]
